import React from 'react';
import WriteBrowserComponent from '../../components/sitter/browser/write/write.browser.component';
import HeaderBrowserComponent from '../../components/sitter/browser/header.browser.component';

const SitterWriteMobileScreen = ({ closeDialog, ...props }: { closeDialog?: () => void }) : React.ReactElement => {
    
    return (
        <div style={{ overflow: "hidden" }}>
            <HeaderBrowserComponent />
            <WriteBrowserComponent closeDialog={closeDialog} />
        </div>
    );
};

export default SitterWriteMobileScreen